import React from 'react'
import {
  RESTRICTED_ACCOUNT_MESSAGE,
  RESTRICTED_ACCOUNT_CONTACT,
  SUPPORT_EMAIL
} from '../../../utils/restrictedAccount'
import './styles.css'

// SPEC-119 D3: what a terminated account sees once it has proven ownership
// on any login surface — the same sentence everywhere, with a way to reach
// support, and nothing else.
function RestrictedAccountNotice() {
  return (
    <p className="restricted-account" role="alert">
      {RESTRICTED_ACCOUNT_MESSAGE} {RESTRICTED_ACCOUNT_CONTACT}{' '}
      <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
    </p>
  )
}

export default RestrictedAccountNotice
